// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 378) return "static/chunks/378-4317bb3c98223411.js";
	if (chunkId === 691) return "static/chunks/691-e27b523811cbbb6d.js";
	if (chunkId === 437) return "static/chunks/437-c19154d95a814184.js";
	if (chunkId === 792) return "static/chunks/main-827aa9ffbe76cd23.js";
	if (chunkId === 636) return "static/chunks/pages/_app-956055a99b7b29d2.js";
	if (chunkId === 593) return "static/chunks/framework-7ac18a18ac76f5a6.js";
	if (chunkId === 423) return "static/chunks/423-1dc2a1eb9b84f4d3.js";
	if (chunkId === 679) return "static/chunks/679-5b61705c737004b4.js";
	if (chunkId === 719) return "static/chunks/719-c5ae5dc494b3438c.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 978 ? "cbcc6fff" : chunkId) + "." + {"76":"8fe427d14644bed0","144":"fd9fce9e9fa93e98","223":"cabf72ddcf384fd3","411":"2a3fa230c421fe3d","475":"122b0d7477a431e5","488":"694dee5374ab56e3","586":"4b0223a1dabb5dc7","795":"3784f7aa1d39cb39","878":"789c6454311b32cb","978":"fd82f0dc2249fab6"}[chunkId] + ".js";
};